import {RouterView} from "vue-router";
import {SurveilanceRouting} from "@/views/inspection-management/surveilance-video/surveilance-video.routing";
import RecordsRouting from "@/views/inspection-management/records/records.routing";
import InspectionSetting from "@/views/inspection-management/setting/inspection.setting.routing";

export const InspectionRouting = {
    path: "/inspection",
    name: "inspection",
    redirect: "/inspection/surveilanc",
    component: RouterView,
    meta: { title: "巡检管理", icon: "news" },
    children: [
        ...SurveilanceRouting,
      ...RecordsRouting,
        ...InspectionSetting
    ],
};
